module.exports = __webpack_public_path__ + "images/icon-directory.1db4af.svg";